import styled from "styled-components";

export const FileDownloadButton = styled.button`
  display: flex;
  justify-content: center; /* Center content horizontally */
  align-items: center;
  
  padding: 10px 20px;
  background: ${({theme}) => theme.grayBackground}; /* Light background */
  border: none;
  border-radius: 12px;
  outline: none;

  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.2px;
  color: ${({theme}) => theme.accent}; /* Primary color text */

  transition: all 300ms ease;
  
  > svg {
    margin-left: 8px;
    fill: ${({theme}) => theme.accent}; /* Same color as text */
  }

  :hover {
    cursor: pointer;
    background: ${({theme}) => theme.accentLightest};
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    width: 100%;
  }
`;